
import SeasonDashboard from '@/components/SeasonDashboard.component.vue'

export default {
  name: 'Home',
  components: {
    SeasonDashboard
  }
}
